import classNames from 'classnames'
import './index.scss'
import {CloseIcon, FilterIcon, RefreshIcon, SearchIcon} from '../../icons'
import DateInterval from '../../components/pages/dateInterval'
import {ImgButton} from '../../components/core/button'
import InputWithIcon from '../../components/core/inputWithIcon'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const SearchSection = ({
    onChange,
    onOpenModal,
    filteredFieldsCount,
    filteredLogGroupsCount,
    onClearFilters,
    isDarkMode,
    searched,
    onSearch,
    onClearLogsGroupFilter,
    isAdditionalFilterEnabled,
    isAdditionalFilterActive,
    text
}) => (
    <div className="search-container">
        <span className="logs-search-field">
            <InputWithIcon
                placeholder={text.search_for_logs}
                icon={<SearchIcon />}
                type="text"
                value={searched}
                name="search"
                className="search-input"
                onIconClick={onSearch}
                onChange={onChange}
            />
        </span>
        {isAdditionalFilterEnabled && (
            <div className={classNames('filters-field log-scope', {
                'has-filters': isAdditionalFilterActive,
                dark: isDarkMode
            })}>
                <ImgButton
                    className="filter-button"
                    onClick={() => onOpenModal(text.modal_ids.log_group_filters)}
                >
                    <FilterIcon />
                    {text.log_group_filters}
                    {filteredLogGroupsCount > 0 && <span>{filteredLogGroupsCount}</span>}
                </ImgButton>
                <span className="clear-filters-icon" onClick={onClearLogsGroupFilter}>
                    <CloseIcon width={16} height={16} />
                </span>
            </div>
        )}
        <div className={classNames('filters-field', {
            'has-filters': filteredFieldsCount > 0,
            dark: isDarkMode
        })}>
            <ImgButton
                className="filter-button"
                onClick={() => onOpenModal(text.modal_ids.field_filters)}
            >
                <FilterIcon />
                {text.filters}
                {filteredFieldsCount > 0 && <span>{filteredFieldsCount}</span>}
            </ImgButton>
            <span className="clear-filters-icon" onClick={onClearFilters}>
                <CloseIcon width={16} height={16} />
            </span>
        </div>
    </div>
)

const RefreshButton = ({isDarkMode, onRefresh, refreshText}) => (
    <ImgButton className={classNames('refresh-button', {dark: isDarkMode})} onClick={onRefresh}>
        <RefreshIcon className="refresh-icon" />
        {refreshText}
    </ImgButton>
)

const PageHeader = ({
    isDarkMode,
    setActiveFiltersModalId,
    filteredFieldsCount,
    filteredLogGroupsCount,
    onClearFilters,
    onResetDate,
    callbackFn,
    setSearched,
    onSearch,
    onRefresh,
    searched,
    isAdditionalFilterEnabled = false,
    isAdditionalFilterActive,
    onClearLogsGroupFilter
}) => {
    const handleSearchChange = (e) => setSearched(e.target.value)
    const openFiltersModal = (modalId) => setActiveFiltersModalId(modalId)
    const text = useNamespaceTranslations('log-management')

    return (
        <div className="logs-header">
            <div className="logs-header-search">
                <SearchSection
                    onChange={handleSearchChange}
                    onOpenModal={openFiltersModal}
                    filteredFieldsCount={filteredFieldsCount}
                    onClearFilters={onClearFilters}
                    isDarkMode={isDarkMode}
                    searched={searched}
                    onSearch={onSearch}
                    onClearLogsGroupFilter={onClearLogsGroupFilter}
                    isAdditionalFilterEnabled={isAdditionalFilterEnabled}
                    isAdditionalFilterActive={isAdditionalFilterActive}
                    filteredLogGroupsCount={filteredLogGroupsCount}
                    text={text}
                />
            </div>
            <div className="logs-header-right">
                <DateInterval resetFn={onResetDate} callbackFn={callbackFn} showMs/>
                <RefreshButton isDarkMode={isDarkMode} onRefresh={onRefresh} refreshText={text.refresh}/>
            </div>
        </div>
    )
}

export default PageHeader
